module.exports = __webpack_public_path__ + "img/ejournal-logo.e300be03.svg";